const images: any[] = Array.from(Array(30), (_, index) =>
  require(`../../assets/images/work/${index + 1}.jpg`)
);

export default images;
